import Hls from "hls.js";
import { ComponentProps, useLayoutEffect, useRef } from "react";

export interface HlsPlayerProps extends ComponentProps<"video"> {
  className?: string;
}

export const HlsPlayer = ({ className, src, ...props }: HlsPlayerProps) => {
  const videoRef = useRef<HTMLVideoElement>(null!);

  useLayoutEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    if (video.canPlayType("application/vnd.apple.mpegurl")) {
      video.src = src!;
    } else if (Hls.isSupported()) {
      const hls = new Hls();
      hls.loadSource(src!);
      hls.attachMedia(video);
    }
  }, [src]);

  return <video ref={videoRef} playsInline className={className} {...props} />;
};
